import React, { ReactElement, ReactText, ReactNode } from 'react';
import { View } from 'react-native';
import { Tappable, TappableProps } from 'src/components/Tappable/Tappable';
import { Clone } from 'src/components/Clone';
import useStyles from './PanelHeaderButton.styles';

export type PanelHeaderButtonProps = TappableProps & {
  children: ReactElement | ReactText;
  label?: ReactNode;
  rounded?: boolean;
};

export const PanelHeaderButton: React.FC<PanelHeaderButtonProps> = ({
  children,
  label,
  rounded = true,
  ...props
}) => {
  const s = useStyles();

  return (
    <Tappable
      style={[s.root, s.color, rounded && s.rounded]}
      accessibilityRole="button"
      {...props}
      hoverable
    >
      <View style={s.content}>
        <Clone style={s.color}>{children}</Clone>
        {label && <View style={s.label}>{label}</View>}
      </View>
    </Tappable>
  );
};
